import { API_CONFIG } from '../config/api';
import { getSessionStorageItem, setSessionStorageItem } from './safeSessionStorage';

const CLICK_FLAG_PREFIX = 'mc_creator_ref_click:';

/**
 * Ping Mongo via the public AWS click endpoint once per tab session
 * when the visitor actually arrived with ?ref= on the URL.
 */
export function recordCreatorShareLinkClick(rawCode: string): void {
    if (typeof window === 'undefined') return;

    const code = rawCode.trim().replace(/^@+/, '').toLowerCase();
    if (!code || !/^[a-z0-9._]+$/.test(code)) return;

    const flagKey = `${CLICK_FLAG_PREFIX}${code}`;
    if (getSessionStorageItem(flagKey)) return;
    setSessionStorageItem(flagKey, '1');

    const baseUrl = API_CONFIG.BASE_URL.replace(/\/$/, '');
    try {
        void fetch(`${baseUrl}/creators/referral-click`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code, source: 'walkmore' }),
            keepalive: true,
        })?.catch(() => {
            /* click tracking must never block the funnel */
        });
    } catch {
        /* fetch unavailable */
    }
}
